import { installWhyChoose } from "@/mocks/serviceInstalacionData";

export default function InstallWhyChoose() {
  return (
    <section className="py-12 md:py-20 px-4 md:px-8 lg:px-12 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          <div className="reveal">
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-[#0087a4] mb-6 leading-tight">
              &iquest;Por Qu&eacute; Elegirnos?
            </h2>

            <ul className="space-y-4">
              {installWhyChoose.map((item, i) => (
                <li
                  key={i}
                  className="reveal flex items-start gap-3"
                  style={{ transitionDelay: `${i * 80}ms` }}
                >
                  <div className="w-5 h-5 rounded-full bg-[#0087a4] flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-check-line text-white text-xs" />
                  </div>
                  <span className="text-foreground-700 text-sm md:text-base leading-relaxed">
                    {item.title}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div className="reveal relative h-[300px] md:h-[450px] rounded-lg overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Multiple%20white%20air%20conditioning%20outdoor%20condenser%20units%20installed%20on%20metal%20cage%20attached%20to%20modern%20building%20exterior%20wall%2C%20vertical%20arrangement%20of%20VRF%20units%2C%20HVAC%20professional%20installation%20photography%2C%20urban%20commercial%20setting%2C%20earth%20tones%20with%20blue%20sky&width=600&height=800&seq=instalacion-whychoose-1&orientation=portrait"
              alt="Instalaci&oacute;n profesional de unidades exteriores"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}